import React from 'react';
import { isEqual } from "underscore";
// import "./TableNoteBook.css";

export default class TableNoteBook extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: props.sampleProjects,
            rowsPerPage: 5,
            page: 0
        };
    }
    componentDidUpdate ( prevProps , prevState ) {
        if(!isEqual(prevProps.sampleProjects , this.props.sampleProjects)){
            this.setState({ rows : this.props.sampleProjects})
        }
    }
    renderTableHeader() {
        return (
            <div className="table-row ">
                <div className="cell col-name"><div className="cell-title">Name</div></div>
                {/* <div className="cell col-sources"><div className="cell-title">Sources</div></div> */}
                <div className="cell col-created"><div className="cell-title">Created</div></div>
                <div className="cell col-role"><div className="cell-title">Action</div></div>
            </div>
        );
    }

    renderRow(row) {
        return (
            <div className="table-row">
                <div className="cell col-name">
                    <div className="name-inner">
                        {/* <div className="avatar-cell">{this.renderAvatars(row.avatars)}</div> */}
                        <div className="title-cell">{row.title}</div>
                    </div>
                </div>

                {/* <div className="cell col-sources"><div className="cell-text">{row.sources}</div></div> */}
                <div className="cell col-created"><div className="cell-text">{row.date}</div></div>

                <div className="cell col-actions">
                    <div className="icon-menu">
                        <div className="icon-menu">
                            <button
                                type="button"
                                className="gen-ai-common-popup__icon-btn"
                                title="View"
                                onClick={() => this.props.handleViewExisting(row.id, row.title)}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_1683_4216)">
                                        <path d="M1.61341 8.47537C1.52262 8.33161 1.47723 8.25973 1.45182 8.14886C1.43273 8.06559 1.43273 7.93425 1.45182 7.85097C1.47723 7.74011 1.52262 7.66823 1.61341 7.52447C2.36365 6.33648 4.59682 3.33325 8.00004 3.33325C11.4033 3.33325 13.6364 6.33648 14.3867 7.52447C14.4775 7.66823 14.5228 7.74011 14.5483 7.85097C14.5673 7.93425 14.5673 8.06559 14.5483 8.14886C14.5228 8.25973 14.4775 8.33161 14.3867 8.47537C13.6364 9.66336 11.4033 12.6666 8.00004 12.6666C4.59682 12.6666 2.36365 9.66336 1.61341 8.47537Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M8.00004 9.99992C9.10457 9.99992 9.99997 9.10449 9.99997 7.99992C9.99997 6.89535 9.10457 5.99992 8.00004 5.99992C6.89551 5.99992 6.00011 6.89535 6.00011 7.99992C6.00011 9.10449 6.89551 9.99992 8.00004 9.99992Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1683_4216">
                                            <rect width="15.9994" height="16" rx="4" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </button>
                        </div>
                        <div className="icon-menu">
                            <button
                                type="button"
                                className="gen-ai-common-popup__icon-btn"
                                title="Delete"
                                onClick={() => this.props.handleDeleteExisting(row.id)}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.6664 3.99992V3.46659C10.6664 2.71985 10.6664 2.34648 10.521 2.06126C10.3932 1.81038 10.1892 1.60641 9.93837 1.47858C9.65317 1.33325 9.27981 1.33325 8.5331 1.33325H7.46647C6.71976 1.33325 6.34641 1.33325 6.0612 1.47858C5.81033 1.60641 5.60636 1.81038 5.47854 2.06126C5.33322 2.34648 5.33322 2.71985 5.33322 3.46659V3.99992M2 3.99992H13.9996M12.6663 3.99992V11.4666C12.6663 12.5867 12.6663 13.1467 12.4483 13.5746C12.2566 13.9509 11.9506 14.2569 11.5743 14.4486C11.1465 14.6666 10.5865 14.6666 9.4664 14.6666H6.53317C5.41311 14.6666 4.85308 14.6666 4.42527 14.4486C4.04896 14.2569 3.74301 13.9509 3.55127 13.5746C3.33329 13.1467 3.33329 12.5867 3.33329 11.4666V3.99992" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>

                    </div>
                </div>

                <div className="cell col-role"><div className="cell-text">{row.role}</div></div>
            </div>
        );
    }

    render() {
        const { rows } = this.state;

        return (
            <div className="panel-root">
                {/* title */}
                <div className="table-row">
                    <div className="page-heading">My Projects</div>
                </div>

                {/* table container */}
                <div className="panel-content">
                    {/* header row */}
                    <div className="table-head-wrapper">
                        {this.renderTableHeader()}
                    </div>

                    {/* rows */}
                    <div className="div-table-root">
                        {rows.map((r) => this.renderRow(r))}
                    </div>
                </div>
            </div>

        );
    }
}